import { FC } from 'react';
import { Action, Label, TableBody, TableHeader, TableRow } from '../../atoms';
import { Table } from '../../molecules';
import dayjs from 'dayjs';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';

export interface LandscapesTemplateProps {
  data: StoryResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeUpdateOrganism: FC<LandscapesTemplateProps> = ({
  data,
  handleEdit,
  handleDelete,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow header={true}>
          <Label bold content="Stories" />
          <Label bold content="Writer" />
          <Label bold content="Date" />
          <Label></Label>
          <Label></Label>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row: StoryResponseDto) => (
          <TableRow key={row.id}>
            <Label content={row.name}></Label>
            <Label content={row.writer ?? ''}></Label>
            <Label content={dayjs(row.date).format('D MMM YYYY').toString()} />
            <Action
              type="edit"
              size="sm"
              onClick={() => handleEdit(row.id)}
            ></Action>
            <Action
              type="delete"
              itemName={row.name}
              size="sm"
              onClick={() => handleDelete(row.id)}
            ></Action>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default LandscapeUpdateOrganism;
